import React, { useState } from "react";
import "./css/BottomBar.css";

const disclaimerString =
  "This website is not affiliated with nor endorsed by Magic: The Gathering™ or Wizards of the Coast. Magic: the Gathering is trademark and copyright Wizards of the Coast, Inc., a subsidiary of Hasbro, Inc. All rights reserved. Card backgrounds used on this site are used with credit to Magic Set Editor under the Creative Commons BY-NC-SA 2.5 License.";

const BottomBar = () => {
  const [extra, setExtra] = useState("");
  const [selected, setSelected] = useState("");

  const show = (e) => {
    let toShow = e.target.id;
    if (toShow === selected) {
      toShow = "";
    }
    setSelected(toShow);
    if (toShow === "faq") {
      setExtra(
        <div className="extra">
          <div className="question">Q: How do I get the image?</div>
          <div className="answer">
            A: Right click on the card and then "save as", after that you're on
            your own.
          </div>
          <div className="question">Q: Will you add (insert feature)?</div>
          <div className="answer">
            A: Maybe, message me on reddit u/cob50nm and I'll think about it.
          </div>
          <div className="question">
            Q: I'm a designer who wants to volunteer to help make the site look
            better, are you interested?
          </div>
          <div className="answer">
            A: Yes please, message me on reddit u/cob50nm and we can talk.
          </div>
          <div className="question">
            Q: I'm a developer, do you want help maintaining/implementing
            (feature request)?
          </div>
          <div className="answer">
            A: I appreciate the offer, but I'm good thanks.
          </div>
          <div className="question">Q: Is this an official product?</div>
          <div className="answer">A: Nope, not at all.</div>
          <div className="question">
            Q: I work for WotC and this violates our fair use policy, can you
            take it down?
          </div>
          <div className="answer">
            A: Sure thing, message me on reddit u/cob50nm and hopefully we can
            find a middle ground.
          </div>
        </div>
      );
    } else if (toShow === "disclaimer") {
      setExtra(<div className="extra">{disclaimerString}</div>);
    } else {
      setExtra("");
    }
  };
  return (
    <div className="bottomBar">
					
			
      <div className="bottomBarOptions">
        <div
          className={selected === "faq" ? "bottomBarSelected" : "bottomBarItem"}
          id="faq"
          onClick={show}
        >
          FAQ
        </div>
        <div
          className={
            selected === "disclaimer" ? "bottomBarSelected" : "bottomBarItem"
          }
          id="disclaimer"
          onClick={show}
        >
          Disclaimer
        </div>
				<div >
					<a href={"https://www.buymeacoffee.com/cob50nm"} target={"_blank"}>
						<img src={"https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"} alt="Buy Me A Coffee" className="coffeebutton" ></img>
				</a>
				</div>
      </div>

      {extra}
    </div>
  );
};

export default BottomBar;
